
/**
 *
 * @class Orientation
 *
 * orientation of canvas objects (where applicable)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export enum Orientation {
  LEFT   = 'left',
  RIGHT  = 'right',
  TOP    = 'top',
  BOTTOM = 'bottom'
}

